// Classes shared by FavoriteDetails and FavoritesChecklist. Rules that portrait or
// brand styles override stay in app/css/favorites.css.
export const FAVORITE_DETAILS =
  "favorite-details tw:relative tw:grow-2 tw:basis-0 tw:bg-[#fff]";
export const FAVORITE_DETAILS_FOOTER_CONTROLS =
  "favorite-details-footer-controls tw:flex tw:flex-col tw:items-stretch";
export const FAVORITE_DETAILS_SCROLLER =
  "favorite-details-scroller tw:grow tw:overflow-auto";
export const FAVORITE_DESCRIPTION = "favorite-description tw:mt-[10px]";
export const FAVORITE_DETAILS_FOOTER =
  "favorite-details-footer tw:bottom-0 tw:[border-top:solid_1px_#f1f1f1] tw:[padding:6px_0_6px_0]";
// font-weight stays in favorites.css: it ties with the tw:[font:inherit] utility
export const FAVORITE_CTA =
  "favorite-cta-btn button type-1 text wide hover tw:relative tw:mr-[45px] tw:ml-[45px] tw:[font:inherit]";
export const FAVORITE_CTA_LABEL =
  "tw:absolute tw:top-[50%] tw:left-0 tw:inline-block tw:w-full tw:[padding:0_3px_0_3px] tw:[transform:translateY(-50%)]";
export const FAVORITE_ANNOTATION =
  "favorite-annotation tw:mb-[4px] tw:inline-block tw:text-center tw:text-[#222] tw:italic";
export const FAVORITE_FOOTNOTE =
  "favorite-footnote tw:mt-[2px] tw:inline-block tw:text-center tw:text-[#222]";
